import PropTypes from 'prop-types'
import { Table } from 'antd'
import { formatCycleRange } from '../../lib/cycles'


export default function ConnectivityRates({ rates }) {
  const columns = [
    {
      key: 'Cycle',
      title: 'Cycle',
      dataIndex: 'key',
      render: (_, record) => formatCycleRange(record.cycle),
    },
    {
      key: 'rate',
      title: 'Rate',
      dataIndex: 'rate',
      render: (_, record) =>
        `${(Number(record.conectivityRate) * 100).toFixed(0)}%`,
    },
  ]

  return (
    <Table
      columns={columns}
      dataSource={rates}
      size="small"
      pagination={false}
    />
  )
}

ConnectivityRates.propTypes = {
  rates: PropTypes.arrayOf(
    PropTypes.shape({
      cycle: PropTypes.shape({
        id: PropTypes.string.isRequired,
        endsAt: PropTypes.string.isRequired,
      }).isRequired,
      conectivityRate: PropTypes.number.isRequired,
    }),
  ).isRequired,
}
